import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

export function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="relative pt-24 pb-10 overflow-hidden"
            style={{ background: '#02050C' }}
        >
            <div
                className="absolute inset-x-0 top-0 h-px"
                style={{ background: 'linear-gradient(90deg, transparent, rgba(6,182,212,0.4), transparent)' }}
            />

            <div className="shell relative">
                <p className="font-display font-semibold text-[18vw] sm:text-[14vw] lg:text-[180px] leading-[0.85] tracking-[-0.06em] text-gradient">
                    ClearAdvance
                </p>
                <p className="mt-6 max-w-md text-[15.5px] leading-[1.6] text-slate-400">
                    A growth systems studio for clinics and serious service
                    businesses. Operating since 2020.
                </p>

                <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 pt-10 border-t border-white/[0.08]">
                    <FooterCol
                        title="Studio"
                        links={[
                            { label: 'What we build', href: '#what-we-build' },
                            { label: 'Featured systems', href: '#featured-systems' },
                            { label: 'Method', href: '#how-we-work' },
                            { label: 'Why us', href: '#why-us' },
                        ]}
                    />
                    <FooterCol
                        title="Services"
                        links={[
                            { label: 'Websites', href: '#what-we-build' },
                            { label: 'Web & mobile apps', href: '#what-we-build' },
                            { label: 'Digital marketing', href: '#what-we-build' },
                            { label: 'AI follow-up', href: '#what-we-build' },
                        ]}
                    />
                    <FooterCol
                        title="Connect"
                        links={[
                            { label: 'hello@clearadvance.co', href: 'mailto:hello@clearadvance.co', external: true },
                            { label: 'Book a strategy call', href: 'mailto:hello@clearadvance.co?subject=Strategy%20Call', external: true },
                            { label: 'Brief a project', href: 'mailto:hello@clearadvance.co?subject=Brief%20a%20project', external: true },
                        ]}
                    />
                    <FooterCol
                        title="Files"
                        links={[
                            { label: 'Zubite.bg', href: '/portfolio/zubite-platform', internal: true },
                            { label: 'CutCraft Racing', href: '/portfolio/cutcraft-racing', internal: true },
                            { label: 'CutCraft Studio', href: '/portfolio/cutcraft-studio', internal: true },
                            { label: 'Здравословно Дишане', href: '/portfolio/detetodisha', internal: true },
                        ]}
                    />
                </div>

                <div className="mt-16 pt-8 border-t border-white/[0.08] flex flex-col sm:flex-row sm:items-center justify-between gap-3 font-mono text-[10.5px] tracking-[0.22em] uppercase text-slate-500">
                    <p>© ClearAdvance Marketing · 2020 — 2026</p>
                    <p>Designed & built in-house</p>
                </div>
            </div>
        </footer>
    );
}

function FooterCol({ title, links }) {
    return (
        <div>
            <p className="font-mono text-[10px] tracking-[0.24em] uppercase font-medium text-cyan-400">
                {title}
            </p>
            <ul className="mt-5 space-y-3">
                {links.map((l) => (
                    <li key={l.label}>
                        {l.internal ? (
                            <Link to={l.href} className="text-[14px] text-slate-300 hover:text-white transition-colors duration-300 inline-flex items-center gap-1.5">
                                {l.label}
                                <ArrowUpRight className="w-3 h-3 opacity-60" />
                            </Link>
                        ) : (
                            <a
                                href={l.href}
                                {...(l.external ? {} : {})}
                                className="text-[14px] text-slate-300 hover:text-white transition-colors duration-300 inline-flex items-center gap-1.5"
                            >
                                {l.label}
                                {l.external && <ArrowUpRight className="w-3 h-3 opacity-60" />}
                            </a>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
}
